export default theme => ({
    titleContainer: {
        borderBottom: 'solid 1px #D2D0D0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 64,
        padding: 0,
        '& .titleButton': {
            position: 'absolute',
            '&.left': {
                left: 10,
            },
            '&.right': {
                right: 10,
            },
        },
        '& .title': {
            flexGrow: 1,
            fontSize: 15,
            lineHeight: 'inherit',
            textTransform: 'uppercase',
            margin: 0,
            textAlign: 'center',
            fontWeight: 'normal'
        },
    },
});
